module.exports = __webpack_public_path__ + "files/414acbfee1a71cb57f9c0ed9f3f4b6d5.png";